// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Zaok","content":"styles_content__edt8l","checkbox":"styles_checkbox__2cd-z","checkboxLabel":"styles_checkboxLabel__1cxXB"};